import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "social-share-nav" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_share_network = _resolveComponent("share-network")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.networks, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (item === 'link')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: _normalizeClass(`btn social-share-nav-item social-share-nav-item--${item}`),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleLinkShare($event)))
                }, [
                  _createVNode(_component_inline_svg, {
                    src: require(`@dw_boilerplate/Partials/Icons/Social/${_ctx.capitalize(item)}.svg`)
                  }, null, 8, ["src"])
                ], 2)
              ]))
            : (_openBlock(), _createBlock(_component_share_network, {
                key: 1,
                network: item,
                class: _normalizeClass(`social-share-nav-item social-share-nav-item--${item}`),
                url: _ctx.url,
                title: _ctx.title
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_inline_svg, {
                    src: require(`@dw_boilerplate/Partials/Icons/Social/${_ctx.capitalize(item)}.svg`)
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1032, ["network", "class", "url", "title"]))
        ], 64))
      }), 256))
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.isFlashMsgActive)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('copied_to_clipboard')), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}